module.exports = __webpack_public_path__ + "static/img/image_solutions_ic_01.ee046ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_ic_01.png
// module id = 49go
// module chunks = 10